import React from "react";
import { EuiLink } from "@elastic/eui";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        sortable: true,
        width: 70,
    },
    {
        field: "email",
        name: "E-Mail",
        sortable: true,
    },
    {
        field: "updatedAt",
        dataType: "date",
        name: "Last login",
        sortable: true,
    },
    {
        field: "createdAt",
        dataType: "date",
        name: "Join Date",
        sortable: true,
    },
    {
        field: "creatorId",
        name: "Creator id",
        sortable: false,
    },
    {
        field: "creatorEmail",
        name: "Creator email",
        sortable: false,
    },
    {
        field: "creatorType",
        name: "Creator type",
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
